import React from 'react';

export interface ChannelBannerProps {
  channel: any;
}

const CHANNEL_ID = 'UCBIXuTOBxbuq4jY2yWW9oOg';

const ChannelBanner: React.FC<ChannelBannerProps> = ({ channel }) => {
  if (!channel) return null;
  return (
    <div className="relative flex flex-col md:flex-row items-center gap-4 mb-8 p-6 bg-[#18181b] rounded-2xl shadow-lg border border-[#23272e]">
      <img
        src={channel.snippet.thumbnails.high?.url || channel.snippet.thumbnails.default.url}
        alt={channel.snippet.title}
        className="w-20 h-20 rounded-full shadow-lg border-2 border-[#14F195] object-cover transition-transform duration-200 hover:scale-105"
        loading="lazy"
      />
      <div className="flex-1 text-center md:text-left">
        <h2 className="text-2xl font-bold text-white mb-1 flex items-center justify-center md:justify-start gap-2">
          {channel.snippet.title}
          {/* Optionally add a verified badge here */}
        </h2>
        <p className="text-gray-400 text-sm mb-2 max-w-2xl mx-auto md:mx-0">{channel.snippet.description}</p>
        <span className="text-[#14F195] font-semibold text-sm">{Number(channel.statistics.subscriberCount).toLocaleString()} subscribers</span>
      </div>
      <div className="absolute bottom-4 right-4 md:static md:ml-auto flex-shrink-0">
        <a
          href={`https://www.youtube.com/channel/${CHANNEL_ID}?sub_confirmation=1`}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 px-5 py-2 bg-[#FF0000] text-white font-bold rounded-full shadow hover:bg-[#d90000] transition-transform duration-200 hover:scale-105 text-base focus:outline-none focus:ring-2 focus:ring-[#14F195]"
          aria-label="Subscribe to YouTube channel"
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" className="inline-block"><path d="M23.498 6.186a2.994 2.994 0 0 0-2.112-2.12C19.228 3.5 12 3.5 12 3.5s-7.228 0-9.386.566a2.994 2.994 0 0 0-2.112 2.12C0 8.355 0 12 0 12s0 3.645.502 5.814a2.994 2.994 0 0 0 2.112 2.12C4.772 20.5 12 20.5 12 20.5s7.228 0 9.386-.566a2.994 2.994 0 0 0 2.112-2.12C24 15.645 24 12 24 12s0-3.645-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>
          Subscribe
        </a>
      </div>
    </div>
  );
};

export default ChannelBanner; 